/**
 * Centralised language → direction logic.
 *
 * Used by App.jsx and LanguageSwitcher.jsx. Keeping it in one place avoids
 * drift (e.g. one place adds Urdu as RTL but the other doesn't).
 */

export const RTL_LANGUAGES = new Set(['ar', 'he']);

/** Strip locale suffix so "ar-EG" → "ar". */
const baseLang = (lang) =>
  typeof lang === 'string' ? lang.toLowerCase().split(/[-_]/)[0] : '';

export function isRtl(lang) {
  return RTL_LANGUAGES.has(baseLang(lang));
}

export function getDir(lang) {
  return isRtl(lang) ? 'rtl' : 'ltr';
}

/**
 * Mutate <html dir> + <html lang> to match the given language.
 * Kept side-effect-free when called with undefined (no-op).
 */
export function applyDocumentDirection(lang) {
  if (typeof document === 'undefined') return;
  document.documentElement.dir = getDir(lang);
  if (typeof lang === 'string' && lang.length > 0) {
    document.documentElement.lang = lang;
  }
}
